export enum CheckboxState {
  Unchecked = 0,
  Checked = 1,
  Indeterminate = 2,
}
